/**
 * @param {AmountMinConf} data
 * @returns {AmountMinConf}
 */
export function initAmountMinConf(data) {
    data = {
        ...(data || {}),
        enabled: data?.enabled ?? false,
        value: data?.value ?? 0,
    };

    return data;
}

/**
 * @typedef {object} AmountMinConf
 *
 * @property {boolean} enabled
 * @property {number} value
 */
